export default "__VITE_ASSET__9bom9xKt__"